/* eslint-disable @typescript-eslint/switch-exhaustiveness-check */
import { SubmitEventType, SubmitStatus } from '~/orderingApp/types';
import type { SubmitReducerState, SubmitReducerEvent } from '~/orderingApp/types';

const initialState: SubmitReducerState = {
  error: null,
  status: SubmitStatus.INITIAL,
};

export const submitReducer = (prevState: SubmitReducerState = initialState, event: SubmitReducerEvent): SubmitReducerState => {
  const nextState = { ...prevState };
  switch (prevState.status) {
    case SubmitStatus.INITIAL:
      switch (event.type) {
        case SubmitEventType.START_SUBMIT_VALIDATION:
          nextState.status = SubmitStatus.VALIDATING_SERVER_SIDE;
          break;
      }
      break;
    case SubmitStatus.VALIDATING_SERVER_SIDE:
      switch (event.type) {
        case SubmitEventType.VALIDATE_SERVER_SIDE_DONE:
          if (event.context.error) {
            nextState.status = SubmitStatus.ERROR;
            nextState.error = event.context.error;
          } else {
            nextState.status = SubmitStatus.VALIDATING_CLIENT_SIDE;
          }
          break;
      }
      break;
    case SubmitStatus.VALIDATING_CLIENT_SIDE:
      switch (event.type) {
        case SubmitEventType.VALIDATE_CLIENT_SIDE_DONE:
          if (event.context.error) {
            nextState.status = SubmitStatus.ERROR;
            nextState.error = event.context.error;
          } else {
            nextState.status = SubmitStatus.SUBMITTING;
          }
          break;
      }
      break;
    case SubmitStatus.SUBMITTING:
      switch (event.type) {
        case SubmitEventType.SUBMIT_DONE:
          if (event.context.error) {
            nextState.status = SubmitStatus.ERROR;
            nextState.error = event.context.error;
          } else {
            nextState.status = SubmitStatus.COMPLETED;
          }
          break;
      }
      break;
    case SubmitStatus.COMPLETED:
      break;
    case SubmitStatus.ERROR:
      switch (event.type) {
        case SubmitEventType.CLEAR_ERROR:
          nextState.status = SubmitStatus.INITIAL;
          nextState.error = null;
          break;
      }
      break;
  }
  return nextState;
};
